/* ============================================================
   LE STUDIO - Configurateur de modernisation A.bsolument
   État central unique, rendu complet à chaque action.
   Les URLs des scènes (assets versionnés) sont injectées par
   Liquid dans le JSON #cfg-data.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('cfg');
  if (!root) return;
  var SCENES = JSON.parse(document.getElementById('cfg-data').textContent);

  var CDN = 'https://cdn.shopify.com/s/files/1/0760/1835/2455/files/';
  var IMG = {
    flax: CDN + 'ACC-FLAX-accessoire-vintage-absolument-1_400x.jpg',
    bam: CDN + 'ACC-BAM-accessoire-vintage-absolument-6_400x.jpg',
    cub: CDN + 'ACC-CUB-EVO-accessoire-vintage-absolument-1_400x.jpg',
    dab: CDN + 'ACC-DAB-accessoire-vintage-absolument-1_400x.jpg',
    wiim: CDN + 'ACC-WIIM-accessoire-vintage-absolument-2_400x.jpg',
    platine: CDN + 'platine-t1-bt-walnut-pro-ject-enceinte-connectee-design-haut-de-gamme-vintage-prodige-radio-941973_400x.webp',
    tissuOrigine: CDN + '2256-radio-vintage-bluetooth-absolument-5_400x.jpg',
    tissuNeuf: CDN + 'Cfg_macro_tissu_neuf.jpg',
    boisVernis: CDN + '2255-radio-vintage-bluetooth-absolument-6_400x.jpg',
    boisNeuf: CDN + 'Cfg_macro_bois_neuf.jpg'
  };

  /* ----- Catalogue (variant IDs réels, prix au 2026-06-12) ----- */
  var GAMMES = [
    { key: 'salon', name: "Radio de salon 30-60's", sub: 'Le poste de famille, lampes et boiseries',
      price: 499, variant: 51202067890503, compat: ['flax', 'bam', 'cub', 'dab', 'wiim', 'platine'], materials: true,
      forfait: 'haut-parleur Focal, amplificateur 50 W analogique, Bluetooth, rétro-éclairage du cadran, entrée auxiliaire, sortie subwoofer, nettoyage complet' },
    { key: 'nomade', name: "Radio Nomade 70's", sub: 'Compacte, repart partout avec vous',
      price: 229, variant: 51226380730695, compat: ['platine'], materials: false,
      forfait: "batterie rechargeable 12 h, haut-parleur d'origine préservé, amplificateur 5 W classe D, Bluetooth 4.0, commandes piste et lecture, nettoyage complet" },
    { key: 'meuble', name: 'Meuble Radio Vintage', sub: 'La pièce maîtresse de votre salon',
      price: 599, variant: 51235805430087, compat: ['flax', 'bam', 'cub', 'dab', 'wiim', 'platine'], materials: true,
      forfait: '2 haut-parleurs Focal, amplificateur 50 W analogique, Bluetooth, rétro-éclairage du cadran, entrée jack, sortie subwoofer, nettoyage complet' }
  ];
  var SON = [
    { key: 'flax', name: 'Haut-parleur Focal Flax', sub: 'La membrane en lin de nos Pépites. Prix par haut-parleur.', price: 120, variant: 46870396272967, img: IMG.flax },
    { key: 'bam', name: 'Isolation acoustique B.A.M Focal', sub: 'Le coffre vibre moins, vos basses gagnent en assise.', price: 79, variant: 52850158141767, img: IMG.bam },
    { key: 'cub', name: 'Caisson de basse CUB EVO Focal', sub: 'Pour vos grandes pièces et vos soirées.', price: 299, variant: 46866282152263, img: IMG.cub }
  ];
  var ECOUTES = [
    { key: 'dab', name: 'Module FM / DAB+', sub: 'La radio du matin, en qualité numérique.', price: 49, variant: 46871057891655, img: IMG.dab },
    { key: 'wiim', name: 'WiiM Mini, AirPlay 2', sub: 'Multiroom, Spotify Connect, streaming direct.', price: 115, variant: 48915777388871, img: IMG.wiim },
    { key: 'platine', name: 'Platine T1 BT Walnut Pro-Ject', sub: 'Vos vinyles, en direct dans votre radio.', price: 500, variant: 46866748801351, img: IMG.platine }
  ];
  var TISSUS = [
    { key: 'origine', name: "Tissu d'origine", sub: 'Conservé et nettoyé, si son état le permet', img: IMG.tissuOrigine },
    { key: 'neuf', name: 'Nouveau tissu', sub: 'Choisi avec vous parmi nos toiles', img: IMG.tissuNeuf }
  ];
  var BOIS = [
    { key: 'vernis', name: 'Ponçage et vernis', sub: 'La patine de votre histoire, respectée', img: IMG.boisVernis },
    { key: 'plaquage', name: 'Plaquage complet', sub: 'Une seconde jeunesse intégrale, sur devis', img: IMG.boisNeuf }
  ];
  var STEPS = [
    { key: 'piece', eyebrow: 'Étape 01 · La pièce' },
    { key: 'son', eyebrow: 'Étape 02 · Le son' },
    { key: 'ecoutes', eyebrow: 'Étape 03 · Vos écoutes' },
    { key: 'matieres', eyebrow: 'Étape 04 · Les matières' },
    { key: 'atelier', eyebrow: "Étape 05 · Votre ordre d'atelier" }
  ];

  /* ----- État ----- */
  var S = { step: 0, gamme: null, opts: {}, tissu: 'origine', bois: 'vernis', lastSon: null, lastEcoute: null, shownPrice: 0 };
  var autoNext = null;

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return [].slice.call(root.querySelectorAll(sel)); }
  function gamme() { return GAMMES.filter(function (g) { return g.key === S.gamme; })[0] || null; }
  /* Un meuble a toujours DEUX haut-parleurs (Arthur, 15/10/2026), une radio de salon un
     seul : sur un meuble, le Flax se prend par paire (2 x 120 EUR, deux unités au panier). */
  function qte(o, g) { return o.key === 'flax' && g && g.key === 'meuble' ? 2 : 1; }
  function nomOption(o, g) { return qte(o, g) === 2 ? 'Haut-parleurs Focal Flax (paire)' : o.name; }

  /* ----- Étapes actives selon la gamme ----- */
  function stepEnabled(i) {
    var g = gamme();
    if (i === 0 || i === 4) return true;
    if (!g) return false;
    if (i === 1) return g.compat.indexOf('flax') !== -1;
    if (i === 2) return g.compat.length > 0;
    if (i === 3) return g.materials;
    return true;
  }
  function nextStep(from, dir) {
    var i = from + dir;
    while (i > 0 && i < 4 && !stepEnabled(i)) i += dir;
    return Math.max(0, Math.min(4, i));
  }

  /* ----- Prix ----- */
  function total() {
    var g = gamme();
    if (!g) return 0;
    var t = g.price;
    SON.concat(ECOUTES).forEach(function (o) {
      if (S.opts[o.key] && g.compat.indexOf(o.key) !== -1) t += o.price * qte(o, g);
    });
    return t;
  }

  /* ----- Scène : crossfade robuste (decode + classes CSS) ----- */
  var sceneSeq = 0;
  function sceneFor() {
    var g = gamme();
    if (!g) return SCENES.salon_base;
    function k(name) { return SCENES[g.key + '_' + name]; }
    function firstOn(keys, last) {
      var order = last && S.opts[last] ? [last] : [];
      keys.forEach(function (x) { if (order.indexOf(x) === -1) order.push(x); });
      for (var i = 0; i < order.length; i++) {
        var key = order[i];
        if (!S.opts[key]) continue;
        if (key === 'flax' && k('interieur')) return k('interieur');
        if (k(key)) return k(key);
      }
      return null;
    }
    if (S.step === 1) {
      var s1 = firstOn(['bam', 'flax', 'cub'], S.lastSon);
      if (s1) return s1;
    }
    if (S.step === 2) {
      if (S.opts.platine && k('platine')) {
        return (S.tissu === 'neuf' && k('platine_tissu')) ? k('platine_tissu') : k('platine');
      }
      var s2 = firstOn(['dab', 'wiim'], S.lastEcoute);
      if (s2) return s2;
    }
    if (S.tissu === 'neuf') {
      if (S.opts.platine && k('platine_tissu')) return k('platine_tissu');
      if (k('tissu')) return k('tissu');
    }
    if (S.opts.platine && k('platine') && S.step >= 2) return k('platine');
    return k('base');
  }
  function setScene(url) {
    var imgs = $$('.cfg-scene-img');
    var front = imgs[0].classList.contains('is-front') ? imgs[0] : imgs[1];
    var back = front === imgs[0] ? imgs[1] : imgs[0];
    if (front.getAttribute('src') === url) return;
    if (back.getAttribute('src') !== url) back.src = url;
    var seq = ++sceneSeq;
    var go = function () {
      if (seq !== sceneSeq) return;
      back.classList.add('is-front');
      front.classList.remove('is-front');
    };
    /* decode() rend la bascule indépendante des aléas de onload et du cache */
    if (back.decode) back.decode().then(go, go);
    else if (back.complete) go();
    else { back.onload = go; back.onerror = go; }
  }
  function light() {
    var lit = 0.62 + 0.1 * S.step;
    if (S.step >= 4) lit = 1.02;
    $$('.cfg-scene-img').forEach(function (i) {
      i.style.filter = 'brightness(' + lit + ') saturate(' + (0.94 + 0.02 * S.step) + ')';
    });
    $('.cfg-scene-halo').style.opacity = String(0.15 + 0.17 * S.step);
  }
  function preload(g) {
    Object.keys(SCENES).forEach(function (key) {
      if (key.indexOf(g.key + '_') === 0) { var im = new Image(); im.src = SCENES[key]; }
    });
  }

  /* ----- Construction des listes (une fois) ----- */
  function row(host, item, extraClass, onClick, priced) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cfg-row' + (extraClass ? ' ' + extraClass : '');
    b.dataset.key = item.key;
    var img = document.createElement('img');
    img.src = item.img; img.alt = item.name; img.loading = 'lazy';
    var txt = document.createElement('span');
    var nm = document.createElement('span'); nm.className = 'cfg-name'; nm.textContent = item.name;
    var sb = document.createElement('span'); sb.className = 'cfg-sub'; sb.textContent = item.sub;
    txt.appendChild(nm); txt.appendChild(sb);
    var right = document.createElement('span'); right.className = 'cfg-right';
    if (priced) {
      var pr = document.createElement('span'); pr.className = 'cfg-price-line';
      pr.textContent = (item.price != null ? (extraClass === 'cfg-row--gamme' ? item.price + ' EUR' : '+ ' + item.price + ' EUR') : '');
      right.appendChild(pr);
    }
    var dot = document.createElement('span'); dot.className = 'cfg-dot';
    right.appendChild(dot);
    b.appendChild(img); b.appendChild(txt); b.appendChild(right);
    b.addEventListener('click', onClick);
    host.appendChild(b);
    return b;
  }

  GAMMES.forEach(function (g) {
    g.img = SCENES[g.key + '_base'];
    row($('#cfg-gammes'), g, 'cfg-row--gamme', function () {
      if (S.gamme !== g.key) {
        S.opts = {}; S.tissu = 'origine'; S.bois = 'vernis';
        S.lastSon = null; S.lastEcoute = null;
        preload(g);
      }
      S.gamme = g.key;
      render();
      clearTimeout(autoNext);
      if (S.step === 0) autoNext = setTimeout(function () { if (S.step === 0) goto(nextStep(0, 1)); }, 800);
    }, true);
  });
  SON.forEach(function (o) {
    row($('#cfg-son'), o, 'cfg-row--opt', function () {
      S.opts[o.key] = !S.opts[o.key];
      S.lastSon = S.opts[o.key] ? o.key : null;
      render();
    }, true);
  });
  ECOUTES.forEach(function (o) {
    row($('#cfg-ecoutes'), o, 'cfg-row--opt', function () {
      S.opts[o.key] = !S.opts[o.key];
      S.lastEcoute = S.opts[o.key] ? o.key : null;
      render();
    }, true);
  });
  TISSUS.forEach(function (t) {
    row($('#cfg-tissus'), t, 'cfg-row--opt', function () { S.tissu = t.key; render(); }, false);
  });
  BOIS.forEach(function (b2) {
    row($('#cfg-bois'), b2, 'cfg-row--opt', function () { S.bois = b2.key; render(); }, false);
  });

  /* ----- Navigation ----- */
  function goto(i) {
    S.step = i;
    render();
    var panel = $('.cfg-panel');
    if (panel.getBoundingClientRect().top < 0 || window.innerWidth < 920) {
      $('.cfg-app').scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }
  $('#cfg-next').addEventListener('click', function () {
    if (!S.gamme) { $('#cfg-warn').textContent = 'Choisissez votre radio pour continuer.'; return; }
    $('#cfg-warn').textContent = '';
    goto(nextStep(S.step, 1));
  });
  $('#cfg-prev').addEventListener('click', function () { goto(nextStep(S.step, -1)); });
  $$('.cfg-seg').forEach(function (seg, i) {
    seg.addEventListener('click', function () {
      if (!S.gamme && i > 0) return;
      if (i > 0 && !stepEnabled(i)) return;
      goto(i);
    });
  });
  $('#cfg-restart').addEventListener('click', function () { goto(0); });

  /* ----- Panier réel ----- */
  $('#cfg-cart').addEventListener('click', function () {
    var g = gamme();
    if (!g) return;
    var btn = this;
    btn.disabled = true;
    var props = { 'Dossier studio': dossier() };
    if (g.materials) {
      props['Toile acoustique'] = S.tissu === 'neuf' ? "Nouvelle toile, choisie avec l'atelier" : "Toile d'origine conservée si son état le permet";
      props['Ébénisterie'] = S.bois === 'plaquage' ? 'Plaquage complet, sur devis à réception' : "Ponçage et vernis d'origine";
    }
    var items = [{ id: g.variant, quantity: 1, properties: props }];
    SON.concat(ECOUTES).forEach(function (o) {
      if (S.opts[o.key] && g.compat.indexOf(o.key) !== -1) items.push({ id: o.variant, quantity: qte(o, g) });
    });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      window.location.href = '/cart';
    }).catch(function () {
      btn.disabled = false;
      $('#cfg-cart-msg').textContent = "Un imprévu à l'ajout au panier. Réessayez ou écrivez-nous à hello@a-bsolument.fr.";
    });
  });

  var dossierNum = 'AB-' + (1000 + Math.floor(Math.random() * 9000));
  function dossier() { return dossierNum; }

  /* ----- Rendu ----- */
  function euros(n) { return n + ' EUR'; }
  function animPrice(target) {
    var el = $('#cfg-total');
    var from = S.shownPrice;
    if (from === target) { el.textContent = euros(target); return; }
    S.shownPrice = target;
    var t0 = null;
    function tick(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / 380);
      el.textContent = euros(Math.round(from + (target - from) * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
    setTimeout(function () { if (S.shownPrice === target) el.textContent = euros(target); }, 480);
  }

  function render() {
    var g = gamme();

    /* segments */
    $$('.cfg-seg').forEach(function (seg, i) {
      seg.classList.toggle('is-now', i === S.step);
      seg.classList.toggle('is-done', i < S.step);
      seg.style.display = (i === 0 || i === 4 || stepEnabled(i)) ? '' : 'none';
    });

    /* étapes */
    $$('.cfg-step').forEach(function (st, i) {
      st.classList.toggle('is-on', i === S.step);
    });
    $('#cfg-eyebrow').textContent = STEPS[S.step].eyebrow;

    /* lignes gammes */
    $$('#cfg-gammes .cfg-row').forEach(function (r) {
      r.classList.toggle('is-on', g && r.dataset.key === g.key);
    });
    /* options : visibilité par compatibilité + état coché */
    $$('#cfg-son .cfg-row, #cfg-ecoutes .cfg-row').forEach(function (r) {
      var ok = g && g.compat.indexOf(r.dataset.key) !== -1;
      r.style.display = ok ? '' : 'none';
      r.classList.toggle('is-on', !!S.opts[r.dataset.key]);
    });
    /* Flax : libellé et prix de la paire sur un meuble */
    SON.forEach(function (o) {
      if (o.key !== 'flax') return;
      var r = root.querySelector('#cfg-son .cfg-row[data-key="flax"]');
      if (!r) return;
      var paire = qte(o, g) === 2;
      r.querySelector('.cfg-name').textContent = nomOption(o, g);
      r.querySelector('.cfg-sub').textContent = paire
        ? 'La membrane en lin de nos Pépites, pour les deux haut-parleurs du meuble.'
        : o.sub;
      var pr = r.querySelector('.cfg-price-line');
      if (pr) pr.textContent = '+ ' + (o.price * qte(o, g)) + ' EUR';
    });
    $$('#cfg-tissus .cfg-row').forEach(function (r) { r.classList.toggle('is-on', S.tissu === r.dataset.key); });
    $$('#cfg-bois .cfg-row').forEach(function (r) { r.classList.toggle('is-on', S.bois === r.dataset.key); });

    /* forfait de la gamme */
    var ff = $('#cfg-forfait');
    ff.textContent = '';
    if (g) {
      ff.appendChild(document.createTextNode('Compris dans le forfait : '));
      var bb = document.createElement('b');
      bb.textContent = g.forfait;
      ff.appendChild(bb);
    }

    /* scène */
    $('#cfg-scenename').textContent = g ? g.name : 'Votre radio';
    setScene(sceneFor());
    light();
    animPrice(total());

    /* tags */
    var tags = { flax: !!S.opts.flax, bam: !!S.opts.bam, cub: !!S.opts.cub, dab: !!S.opts.dab,
      wiim: !!S.opts.wiim, platine: !!S.opts.platine, tissu: S.tissu === 'neuf', bois: S.bois === 'plaquage' };
    Object.keys(tags).forEach(function (key) {
      var el = $('#cfg-tag-' + key);
      if (el) el.classList.toggle('is-on', tags[key]);
    });

    /* certificat */
    if (S.step === 4 && g) {
      $('#cfg-cert-num').textContent = 'Dossier ' + dossier();
      $('#cfg-cert-date').textContent = new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
      var lines = [['Modernisation ' + g.name, euros(g.price)],
                   ['Forfait atelier complet', 'compris']];
      SON.concat(ECOUTES).forEach(function (o) {
        if (S.opts[o.key] && g.compat.indexOf(o.key) !== -1) lines.push([nomOption(o, g), '+ ' + euros(o.price * qte(o, g))]);
      });
      if (g.materials) {
        lines.push([S.tissu === 'neuf' ? "Nouvelle toile acoustique, choisie avec l'atelier" : "Toile d'origine conservée si son état le permet", 'compris']);
        lines.push([S.bois === 'plaquage' ? 'Plaquage complet' : "Ponçage et vernis d'origine", S.bois === 'plaquage' ? 'sur devis' : 'compris']);
      }
      lines.push(["Garantie à vie de l'atelier", 'comprise']);
      var host = $('#cfg-cert-lines');
      host.textContent = '';
      lines.forEach(function (l) {
        var d = document.createElement('div');
        d.className = 'cfg-cert-line';
        var a = document.createElement('span'); a.textContent = l[0];
        var b = document.createElement('span'); b.textContent = l[1];
        d.appendChild(a); d.appendChild(b);
        host.appendChild(d);
      });
      $('#cfg-cert-total').textContent = euros(total());
    }

    /* navigation : masquée au certificat (le bouton Modifier prend le relais) */
    $('.cfg-nav').style.display = S.step >= 4 ? 'none' : 'flex';
    $('#cfg-prev').style.visibility = S.step === 0 ? 'hidden' : 'visible';
    $('#cfg-next').textContent = S.step === nextStep(4, -1) ? "Voir mon ordre d'atelier" : 'Continuer';
  }

  /* ----- Intro ----- */
  $('#cfg-start').addEventListener('click', function () {
    var intro = $('.cfg-intro');
    intro.classList.add('is-lit');
    setTimeout(function () {
      intro.classList.add('is-out');
      $('.cfg-app').classList.add('is-on');
      render();
      setTimeout(function () {
        intro.style.display = 'none';
        $('.cfg-app').scrollIntoView({ behavior: 'auto', block: 'start' });
      }, 80);
    }, 650);
  });

  /* première passe : scène d'accueil prête */
  setScene(SCENES.salon_base);
  setTimeout(function () { preload(GAMMES[0]); }, 1500);
})();
